import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import {
  ValidateUserRequest,
  UserStatus,
} from '../../../shared/models/ValidatedUser';
import { UserService } from 'src/app/service/user.service';
import {
  EmailLinkRequest,
} from '../../../shared/models/request';
import { SupportDialogComponent } from 'src/app/core/components/support-dialog/support-dialog.component';
import { ToastPopUpComponents } from 'src/app/shared/services/toast-popup.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastOptions } from 'src/app/core/components/toast/toast.component';
import { firstValueFrom, Observable } from 'rxjs';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';
import { LoginService } from 'src/app/service/api/login.service';
import { RecaptchaService } from 'src/app/service/recaptcha.service';

@Component({
  selector: 'app-forgot-password',
  template: `<div id="forgotpassword" class="forgotpasswordContent">
    <div>
      <h1 [attr.aria-label]="pageTitle" id="forgotpwdheading" role="heading">
        {{ pageTitle | sentenceCase}}
      </h1>
    </div>
    <div class="tw-w-full">
      <span role="label"
        >{{'Please follow all prompts to complete the login process.' | translation: translationRequest | sentenceCase}}</span
      >
    </div>
    <div class="forgotpassword-container">
      <div id="forgotPasswordUservalidation" [hidden]="!showforgotPasswordForm">
        <form
          novalidate
          (ngSubmit)="onForgotPasswordSubmit()"
          [formGroup]="forgotPasswordForm"
          role="none"
        >
          <ul class="" role="none">
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center app-mt3"
            >
              <label
                for="usernameId"
                role="label"
                class="tw-w-full md:tw-w-[50%]"
                >{{ usernameQuestionText | sentenceCase }}: *</label
              >
              <mat-form-field class="tw-w-full md:tw-w-[50%]">
                <input
                  matInput
                  tabindex="0"
                  autocomplete="off"
                  required
                  id="usernameId"
                  type="text"
                  placeholder="{{'User name' | translation: translationRequest | sentenceCase}}"
                  formControlName="username"
                  (focusout)="focusOutFunction('usernameerror')"
                  [attr.aria-label]="usernameQuestionText"
                  [ngClass]="{
                    'is-invalid':
                      forgotPasswordForm.get('username').dirty &&
                      !forgotPasswordForm.get('username').valid
                  }"
                />
                <mat-error
                  role="none"
                  tabindex="0"
                  id="usernameerror"
                  class="error-message"
                  *ngIf="(forgotPasswordForm.get('username').errors?.['required'] || forgotPasswordForm.get('username').dirty) && !forgotPasswordForm.get('username').valid"
                >
                  <span>{{'Error : Please enter your user name.' | translation: translationRequest | sentenceCase}}</span>
                </mat-error>
              </mat-form-field>
            </li>

            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center md:tw-justify-end app-mt3"
            >
              <p></p>
              <label>
                <a
                  tabindex="0"
                  [attr.aria-label]="'Forgot user name?' | translation: translationRequest | sentenceCase"
                  role="link"
                  (keydown.enter)="onForgotUsernameClick()"
                  (click)="onForgotUsernameClick()"
                  >{{'Forgot user name?' | translation: translationRequest | sentenceCase}}</a
                >
              </label>
            </li>
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center md:tw-justify-end app-mt3"
            >
              <div class="tw-w-full tw-flex tw-justify-center">
                <div #recaptchaContainer></div>
              </div>
            </li>
            <li
              role="none"
              class="tw-w-full tw-flex tw-justify-center app-mb2"
              *ngIf="captchaError"
            >
              <span class="error-message">{{ captchaError | sentenceCase }}</span>
            </li>
          </ul>

          <div class="tw-w-full tw-flex tw-justify-end app-mt2 ">
            <app-button
              role="button"
              type="button"
              mat-raised-button
              color="whiteButton"
              (click)="onCancel()"
              [attr.aria-label]="'Cancel' | translation: translationRequest | sentenceCase"
              emphasis="Low"
              class="app-mr2"
            >
              {{'Cancel' | translation: translationRequest | sentenceCase}}
            </app-button>

            <app-button
              mat-raised-button
              role="button"
              color="primary"
              type="submit"
              [title]="
                forgotPasswordForm.valid
                  ? ''
                  : ('Disabled until the form data is valid' | translation: translationRequest | sentenceCase)
              "
              [disabled]="!forgotPasswordForm.valid"
              [attr.aria-label]="'Next' | translation: translationRequest"
              emphasis="High"
            >
              {{'Next' | translation: translationRequest | sentenceCase}}
            </app-button>
          </div>
        </form>
      </div>
      <div id="selectResetMethod" *ngIf="showResetmethodForm">
        <form
          role="none"
          novalidate
          [formGroup]="selectResetmethodForm"
          (ngSubmit)="onSelectResetMethodSubmit()"
        >
          <ul class="" role="none">
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center app-mt3"
            >
              <label
                for="resetMethod"
                class="tw-w-full md:tw-w-[50%] "
                role="label"
                >{{'Please select how would you like to reset your password?' | translation: translationRequest | sentenceCase}}</label
              >
              <mat-form-field class="tw-w-full md:tw-w-[50%]">
                <mat-select
                  autocomplete="off"
                  required
                  id="resetMethod"
                  formControlName="resetMethod"
                  [placeholder]="'Select one' | translation: translationRequest | sentenceCase"
                  [attr.aria-label]="'Please select how would you like to reset your password?' | translation: translationRequest | sentenceCase"
                  (selectionChange)="selectedUpdatedMethodChanged()"
                  class="tw-bg-[var(--sed-open-grey-color)]"
                  panelClass="custom-select-panel"
                >
                  <mat-option value="TEXT">{{'Text' | translation: translationRequest | sentenceCase}}</mat-option>
                  <mat-option value="EMAIL_LINK">{{'Email link' | translation: translationRequest | sentenceCase}}</mat-option>
                </mat-select>
                <mat-error
                  role="none"
                  *ngIf="(selectResetmethodForm.get('resetMethod').touched ||
                selectResetmethodForm.get('resetMethod').dirty) && selectResetmethodForm.get('resetMethod').errors?.['required'] &&
                !selectResetmethodForm.get('resetMethod').valid"
                >
                  <span
                    >{{'How would you like to reset your password is required.' | translation: translationRequest | sentenceCase}}</span
                  >
                </mat-error>
              </mat-form-field>
            </li>
            <li
              role="none"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center app-mt3"
              *ngIf="resetMethod === 'EMAIL_LINK'"
            >
              <label
                for="emailOnAccount"
                class="tw-w-full md:tw-w-[50%]"
                role="label"
                >{{'Please enter the email address associated with your account' | translation: translationRequest | sentenceCase}}:
                *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%]"
              >
                <input
                  matInput
                  class="input"
                  type="email"
                  formControlName="emailOnAccount"
                  name="emailOnAccount"
                  required
                  id="emailOnAccount"
                  autocomplete="off"
                  [attr.aria-label]="'Personal email' | translation: translationRequest | sentenceCase"
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    selectResetmethodForm.get('emailOnAccount').invalid &&
                    selectResetmethodForm.get('emailOnAccount').errors &&
                    (selectResetmethodForm.get('emailOnAccount').dirty ||
                      selectResetmethodForm.get('emailOnAccount').touched) &&
                    selectResetmethodForm
                      .get('emailOnAccount')
                      .hasError('required')
                  "
                >
                  <span> {{'Error : Email on account is required.' | translation: translationRequest | sentenceCase}}</span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    selectResetmethodForm.get('emailOnAccount').invalid &&
                    selectResetmethodForm.get('emailOnAccount').errors &&
                    (selectResetmethodForm.get('emailOnAccount').dirty ||
                      selectResetmethodForm.get('emailOnAccount').touched) &&
                    selectResetmethodForm
                      .get('emailOnAccount')
                      .hasError('pattern')
                  "
                >
                  <span> {{'Error : Please enter a valid email.' | translation: translationRequest | sentenceCase}}</span>
                </mat-error>
              </mat-form-field>
            </li>
            <li
              role="none"
              *ngIf="resetMethod === 'TEXT'"
              class="tw-w-full tw-flex tw-flex-col md:tw-flex-row app-mb2 tw-items-center  app-mt3"
            >
              <label
                for="phonenumber"
                class="tw-w-full md:tw-w-[50%]"
                role="label"
                >{{'Please enter the phone number associated with your account' | translation: translationRequest | sentenceCase}}:
                *</label
              >
              <mat-form-field
                [@.disabled]="animationsDisabled"
                class="tw-w-full md:tw-w-[50%]"
              >
                <input
                  matInput
                  class="input"
                  type="phonenumber"
                  formControlName="phoneNumber"
                  name="phoneNumber"
                  required
                  id="phoneNumber"
                  autocomplete="off"
                  [attr.aria-label]="'Personal phone' | translation: translationRequest | sentenceCase"
                />
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    selectResetmethodForm.get('phoneNumber').invalid &&
                    selectResetmethodForm.get('phoneNumber').errors &&
                    (selectResetmethodForm.get('phoneNumber').dirty ||
                      selectResetmethodForm.get('phoneNumber').touched) &&
                    selectResetmethodForm
                      .get('phoneNumber')
                      .hasError('required')
                  "
                >
                  <span> {{'Error : Phone number is required.' | translation: translationRequest | sentenceCase}}</span>
                </mat-error>
                <mat-error
                  role="none"
                  class="error-message"
                  *ngIf="
                    selectResetmethodForm.get('phoneNumber').invalid &&
                    selectResetmethodForm.get('phoneNumber').errors &&
                    (selectResetmethodForm.get('phoneNumber').dirty ||
                      selectResetmethodForm.get('phoneNumber').touched) &&
                    selectResetmethodForm.get('phoneNumber').hasError('pattern')
                  "
                >
                  <span>
                    {{'Error : Please enter phone number in the format xxx-xxx-xxxx.' | translation: translationRequest | sentenceCase}}</span
                  >
                </mat-error>
              </mat-form-field>
            </li>
          </ul>

          <div class="tw-w-full tw-flex tw-justify-end app-mt6">
            <app-button
              role="button"
              type="button"
              mat-raised-button
              class="app-pr2"
              emphasis="Low"
              (click)="onCancel()"
              [attr.aria-label]="'Cancel' | translation: translationRequest"
            >
              {{'Cancel' | translation: translationRequest}}
            </app-button>

            <app-button
              role="button"
              mat-raised-button
              emphasis="High"
              type="submit"
              [attr.aria-label]="'Next' | translation: translationRequest"
              aria-hidden="true"
              [title]="
                selectResetmethodForm.valid
                  ? ''
                  : ('Disabled until mandatory fields are missing' | translation: translationRequest | sentenceCase)
              "
              [disabled]="!selectResetmethodForm.valid"
            >
              {{'Next' | translation: translationRequest}}
            </app-button>
          </div>
        </form>
      </div>

      <br aria-hidden="true" />
      <div
        *ngIf="showToastMessage"
        (click)="showSupportModal ? openSupportDialog() : ''"
      >
        <app-toast
          #toastFocus
          [message]="toastMessage"
          [type]="toastEnumOptions"
          isToastFocus="true"
        ></app-toast>
      </div>
    </div>
  </div> `,
  styles: [
    `
      .forgotpasswordContent {
        margin: 40px;
      }
      .forgotpassword-container {
        width: 80%;
        max-width: 630px;
        margin: 30px;
      }

      .forgotpassword-container * {
        box-sizing: border-box;
      }

      .is-invalid {
        outline: 2;
        border-width: 0 0 2px;
        border-color: var(--red);
      }

      :host {
        --mat-select-panel-background-color: var(--sed-open-grey-color);
      }

      ::ng-deep .custom-select-panel {
        background-color: var(--sed-open-grey-color) !important;
      }
    `,
  ],
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  @ViewChild('recaptchaContainer', { static: true })
  recaptchaContainer: ElementRef;

  pageTitle: string;
  showforgotPasswordForm: boolean = true;
  showSupportModal: boolean = false;
  showNewpasswordForm: boolean = false;
  showResetmethodForm: boolean;
  showSecurityQuestionForm: boolean;
  forgotPasswordForm: UntypedFormGroup;
  securityQuestionsForm: UntypedFormGroup;
  selectResetmethodForm: UntypedFormGroup;
  forgotPasswordRequest: ValidateUserRequest;
  emailLinkRequest: EmailLinkRequest;
  usernameQuestionText: string;
  showToastMessage: boolean;
  toastMessage: string;
  toastEnumOptions: any;
  captchaError: string;
  recaptchaToken: string = '';
  recaptchaWidgetId: number = null;
  recaptchaInitialized = false;
  recaptchaSiteKey: string = '';
  answerList: any;
  toastPopupOptions = ToastPopUpComponents;
  animationsDisabled = true;
  resetMethod: string;
  translationRequest: TranslationRequest = new TranslationRequest(
    {
      language: sessionStorage.getItem('languagepreference'), // Default to English, you can make this dynamic
      key: null,
      contNum: 0,
      tableName: null,
      primaryKey: null,
      primaryValue: null,
      lob: null,     
      group: 'LoginApp',
      subGroup: 'LoginApp'
    }
  );


  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private titleService: Title,
    private userService: UserService,
    private utility: UtilityService,
    public dialog: MatDialog,
    public translationService: TranslationService,
    private loginService: LoginService,
    private recaptchaService: RecaptchaService
  ) {
    this.initializeForms();
  }

  private initializeForms(): void {
    this.forgotPasswordForm = this.fb.group({
      username: ['', [Validators.required]],
    });

    this.selectResetmethodForm = this.fb.group({
      resetMethod: ['', [Validators.required]],
      emailOnAccount: [''],
      phoneNumber: [''],
    });
  }

  ngOnInit(): void {
    this.loadTranslations();
    this.setupInitialState();
    this.setupForms();
    void this.initializeRecaptcha();
  }

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  private setupInitialState(): void {
    this.captchaError = '';
    this.showSupportModal = false;
    this.showforgotPasswordForm = true;
    this.showNewpasswordForm = false;
    this.showSecurityQuestionForm = false;
    this.showResetmethodForm = false;
    this.translationService.getTranslationForKey$('Reset password', this.translationRequest).subscribe((pageTitle) => {
      this.pageTitle = pageTitle;
    });
    this.translationService.getTranslationForKey$('Please provide your user name', this.translationRequest).subscribe((usernameText) => {
      this.usernameQuestionText = usernameText;
    });
    this.translationService.getTranslationForKey$('mySedgwick - Reset password', this.translationRequest).subscribe((title) => {
      this.titleService.setTitle(title);
    });
  }

  private setupForms(): void {
    // Update validators for email and phone fields
    const emailControl = this.selectResetmethodForm.get('emailOnAccount');
    const phoneControl = this.selectResetmethodForm.get('phoneNumber');

    if (emailControl && phoneControl) {
      emailControl.setValidators([
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
        ),
      ]);

      phoneControl.setValidators([
        Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
      ]);
    }

  }

  setValidators(): void {
    const emailControl = this.selectResetmethodForm.get('emailOnAccount');
    const phoneControl = this.selectResetmethodForm.get('phoneNumber');

    if (!emailControl || !phoneControl) return;

    if (this.resetMethod === 'EMAIL_LINK') {
      emailControl.setValidators([
        Validators.required,
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
        ),
      ]);
      phoneControl.clearValidators();
      phoneControl.setValue('');
    } else {
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
      ]);
      emailControl.clearValidators();
      emailControl.setValue('');
    }

    emailControl.updateValueAndValidity();
    phoneControl.updateValueAndValidity();
  }

  selectedUpdatedMethodChanged(): void {
    this.resetMethod = this.selectResetmethodForm.get('resetMethod')?.value;
    this.setValidators();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.setupAccessibilityAttributes(), 1000);
  }

  private setupAccessibilityAttributes(): void {
    const reloadLink = document.getElementById('MeltingHeat_ReloadLink');
    const soundLink = document.getElementById('MeltingHeat_SoundLink');

    if (reloadLink) {
      reloadLink.setAttribute('role', 'button');
    }

    if (soundLink) {
      soundLink.setAttribute('role', 'button');
    }
  }

  onCancel(): void {
    this.router.navigate(['/']);
  }

  onForgotUsernameClick(): void {
    this.router.navigateByUrl('/forgotusername', { skipLocationChange: true });
  }
  openSupportDialog(): void {
    const dialogRef = this.dialog.open(SupportDialogComponent);
  }

  onSelectResetMethodSubmit(): void {
    if (this.selectResetmethodForm.invalid) return;

    this.resetMethod = this.selectResetmethodForm.value.resetMethod;

    this.emailLinkRequest = new EmailLinkRequest({
      userName: this.forgotPasswordRequest.userName,
      emailAddress: this.selectResetmethodForm.value.emailOnAccount,
      mobileNo: this.selectResetmethodForm.value.phoneNumber,
      verifyType: '',
      firstName: '',
      lastName: '',
      delieverBy: '',
      userid: '',
      isChangePasswordRequest: true,
      LanguageCode: sessionStorage.getItem('languagepreference') || 'en',
    });

    // Load translations for toast messages
    this.translationService.getTranslationForKey$('If information is found matching what you provided, a reset link will be sent to you. For email please check your Inbox, Junk and Spam folders.', this.translationRequest).subscribe((message1) => {
      this.translationService.getTranslationForKey$('For additional help please contact Technical Support.', this.translationRequest).subscribe((message2) => {
        this.translationService.getTranslationForKey$('You may close this browser window.', this.translationRequest).subscribe((message3) => {
          this.toastMessage = message1 + '</br></br>' + message2 + '</br></br>' + message3;
        });
      });
    });
    
    // Set delivery method and send email link
    this.emailLinkRequest.delieverBy =
      this.resetMethod == 'EMAIL_LINK' ? 'EmailLink' : 'TextLink';
    
    this.userService.sendEmailLink(this.emailLinkRequest).subscribe(
      (result) => {
        this.showToastMessage = true;
        this.toastEnumOptions = ToastOptions.Success;
        this.showforgotPasswordForm = false;
        this.showNewpasswordForm = false;
        this.showResetmethodForm = false;
        this.showSecurityQuestionForm = false;
        this.showSupportModal = false;
      },
      (e) => {
        this.showforgotPasswordForm = false;
        this.showNewpasswordForm = false;
        this.showResetmethodForm = false;
        this.showSecurityQuestionForm = false;
        this.showToastMessage = true;
        this.showSupportModal = false;
        this.toastEnumOptions = ToastOptions.Success;
      }
    );
  }

  async onForgotPasswordSubmit() {
    if (this.forgotPasswordForm.invalid) return;
    this.captchaError = '';
    const tokenFromWidget = this.recaptchaService.getResponse(
      this.recaptchaWidgetId
    );
    if (!this.utility.isNullOrEmpty(tokenFromWidget)) {
      this.recaptchaToken = tokenFromWidget;
    }
    if (this.utility.isNullOrEmpty(this.recaptchaToken)) {
      await this.setInvalidCaptcha();
      return;
    }

    this.forgotPasswordRequest = new ValidateUserRequest({
      captchaId: 'google-recaptcha',
      userEnteredCaptchaCode: 'google-recaptcha',
      recaptchaToken: this.recaptchaToken,
      userName: this.forgotPasswordForm.value.username,
      email: '',
      textphone: '',
      LanguageCode: sessionStorage.getItem('languagepreference'),
    });

    const result = await firstValueFrom(
      this.userService.validateUser(this.forgotPasswordRequest)
    );

    if (!result) {
      this.setInvalidCaptcha();
      return;
    }

    this.showToastMessage = true;
    switch (result.userStatus) {
      case UserStatus.Valid:
      case UserStatus.Locked:
        this.showforgotPasswordForm = false;
        this.showNewpasswordForm = false;
        this.showResetmethodForm = true;
        this.showToastMessage = false;
        break;
      case UserStatus.NotFound:
        this.translationService.getTranslationForKey$('The system could not validate your information.', this.translationRequest).subscribe((message1) => {
          this.translationService.getTranslationForKey$('Please confirm your entry and try again.', this.translationRequest).subscribe((message2) => {
            this.toastMessage = message1 + '</br>' + message2;
          });
        });
        this.toastEnumOptions = ToastOptions.Info;
        this.resetRecaptcha();
        break;
      case UserStatus.Disabled:
        this.translationService.getTranslationForKey$('Your mySedgwick login has been disabled due to excessive reset attempts. If you have any questions please contact', this.translationRequest).subscribe((message1) => {
          this.translationService.getTranslationForKey$('Sedgwick Support', this.translationRequest).subscribe((supportText) => {
            this.toastMessage = message1 + " <span class='spanLink'>" + supportText + "</span>.";
          });
        });
        this.toastEnumOptions = ToastOptions.Info;
        this.resetRecaptcha();
        break;
      case UserStatus.DeadClient:
        this.translationService.getTranslationForKey$('The system could not validate your information.', this.translationRequest).subscribe((message1) => {
          this.translationService.getTranslationForKey$('Please confirm your entry and try again.', this.translationRequest).subscribe((message2) => {
            this.toastMessage = message1 + '</br>' + message2;
          });
        });
        this.toastEnumOptions = ToastOptions.Info;
        this.resetRecaptcha();
        break;
      case UserStatus.ClientNotSetupYet:
        this.translationService.getTranslationForKey$('Your company is not setup on mySedgwick. Please contact your HR department.', this.translationRequest).subscribe((message) => {
          this.toastMessage = message;
        });
        this.toastEnumOptions = ToastOptions.Info;
        this.resetRecaptcha();
        break;
      case UserStatus.BadCaptCha:
        this.setInvalidCaptcha();
        break;
    }
  }

  async setInvalidCaptcha() {
    this.resetRecaptcha();
    this.toastMessage = '';
    this.translationService.getTranslationForKey$('Please complete the reCAPTCHA verification before continuing.', this.translationRequest).subscribe((errorMessage) => {
      this.captchaError = errorMessage;
    });
  }

  private async initializeRecaptcha(): Promise<void> {
    if (this.recaptchaInitialized) {
      return;
    }

    try {
      const { siteKey } = await firstValueFrom(
        this.loginService.getRecaptchaSiteKey()
      );
      this.recaptchaSiteKey = siteKey;
      await this.recaptchaService.ensureLoaded();
      if (
        this.recaptchaContainer?.nativeElement &&
        this.recaptchaWidgetId === null
      ) {
        const widgetId = this.recaptchaService.render(
          this.recaptchaContainer.nativeElement,
          this.recaptchaSiteKey,
          'FORGOT_PASSWORD',
          {
            onSuccess: (token) => {
              this.recaptchaToken = token;
              this.captchaError = '';
            },
            onExpired: () => {
              this.recaptchaToken = '';
            },
            onError: () => {
              this.recaptchaToken = '';
            },
          }
        );
        if (widgetId !== null) {
          this.recaptchaWidgetId = widgetId;
          this.recaptchaInitialized = true;
        }
      }
    } catch (error) {
      console.error('Unable to load reCAPTCHA script.', error);
    }
  }

  private resetRecaptcha(): void {
    this.recaptchaToken = '';
    this.recaptchaService.reset(this.recaptchaWidgetId);
  }

  focusOutFunction(id: string) {
    // var myEle = document.getElementById(id);
    // if(myEle) {
    //   document.getElementById(id).focus();
    // }
  }
}
